import {ProModal, ProModalProps} from '../../../../../Components/ProModal';
import ProForm from '../../../../../Components/ProForm';
import useRequest from '../../../../../Utils/Hooks/useRequest';
import {getUserListPage} from '../../../UserManage/service';
import SelectDict from '../../../../../Features/Select/SelectDict';
import {FlexBox} from '../../../../../Components/FlexBox';
import {message} from 'antd';
import {errorMessage} from '../../../../../Utils/common';
import {saveUserRole} from '../../service';

interface AddUserModalProps extends ProModalProps {
    roleId: string;
}

export function AddUserModal({roleId, onOk, ...props}: AddUserModalProps) {
    const [userList] = useRequest(() =>
        getUserListPage({}, {pageSize: 9999, pageNo: 1}),
    );

    function filerFunction(inputValue: string, option: any) {
        return option.search.includes(inputValue);
    }

    async function onFinish(data: {userId: string}) {
        try {
            await saveUserRole(data.userId, roleId);
            message.success('添加成功！');
            onOk?.();
        } catch (e) {
            message.error(errorMessage(e));
        }
    }

    return (
        <ProModal.Form
            title="添加授权人员"
            {...props}
            onFinish={onFinish}
            formProps={{columns: 1}}>
            <ProForm.Field label="选择授权用户" name="userId">
                <SelectDict
                    placeholder="输入用户名或用户账号后按下回车进行搜索"
                    options={userList?.data.map(item => ({
                        label: (
                            <FlexBox gap="10px">
                                {item.userName}
                                <FlexBox color="#ccc">{item.loginName}</FlexBox>
                            </FlexBox>
                        ),
                        value: item.id,
                        search: `${item.userName} - ${item.loginName}`,
                    }))}
                    filterOption={filerFunction}
                />
            </ProForm.Field>
        </ProModal.Form>
    );
}
